const toUpper = (str) => {
  if (str !== undefined && str !== null) {
    return str.toString().toUpperCase();
  }
  return null;
};

export default toUpper;
